import React, {useEffect} from "react";
import "../Stylesheets/Home.css";
import MaterialTable from "material-table";
import {renderLander} from "../../components/CommonUtilities/RenderLander";
import CustomizedSnackbars from "../../components/CommonUtilities/CustomizedSnackbars";
import {LOCALIZATION} from "../../components/Material-TableCustomization/Localization/LocalizationES";
import {REMOVE_DROP_SHADOW} from "../../components/Material-TableCustomization/CSSChanges/RemoveDropShadow";
import {ICONS_OVERRIDE_SECONDARY_COLOR} from "../../components/Material-TableCustomization/IconsOverride/IconsOverrideSecondaryColor";
import {STUDENTS_LIGHT_COLUMN_DEFINITION_PROPS} from "../../components/Material-TableCustomization/ColumnsDefinition/StudentsLightColumnDefinition";
import {useStudents} from "../../contexts/StudentsContext";
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from '@material-ui/core/Tooltip';

export default function Home(props) {

    const { students, isLoading, error, loadStudents, forceRefresh, lastFetched } = useStudents();
    const [alertStatus, setAlertStatus] = React.useState({open: false, message: "", severity: ""});

    const handleChangeOnAlert = shouldPresentAlert => {
        setAlertStatus(shouldPresentAlert);
    }

    useEffect(() => {
        if (!props.isAuthenticated) {
            return;
        }
        loadStudents();
    }, [props.isAuthenticated, loadStudents]);

    useEffect(() => {
        if (error) {
            setAlertStatus({open: true, message: error, severity: "error"});
        }
    }, [error]);

    function renderStudents() {
        const getLastUpdatedText = () => {
            if (!lastFetched) return "";
            const minutes = Math.floor((Date.now() - lastFetched) / 60000);
            if (minutes < 1) return "Actualizado hace menos de un minuto";
            if (minutes === 1) return "Actualizado hace 1 minuto";
            return `Actualizado hace ${minutes} minutos`;
        };

        return (
            <div className="Students">
                <MaterialTable
                    columns={STUDENTS_LIGHT_COLUMN_DEFINITION_PROPS(props)}
                    data={students}
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {lastFetched && (
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                    {getLastUpdatedText()}
                                </span>
                            )}
                            <Tooltip title="Actualizar lista">
                                <IconButton 
                                    onClick={forceRefresh}
                                    disabled={isLoading}
                                    color="primary"
                                    style={{ 
                                        backgroundColor: '#3f51b5',
                                        color: 'white',
                                        padding: '6px'
                                    }}
                                >
                                    <RefreshIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    }
                    isLoading={isLoading}
                    options={{
                        search: true,
                        filtering: true,
                        pageSize: 20,
                    }}
                    components={{
                        ...REMOVE_DROP_SHADOW
                    }}
                    icons={ICONS_OVERRIDE_SECONDARY_COLOR}
                    localization={LOCALIZATION('estudiante', 'estudiantes')}
                />
            </div>
        );
    }


    return (
        <div className="Professors">
            <CustomizedSnackbars status={alertStatus} alertCallback={handleChangeOnAlert}/>
            {props.isAuthenticated ? renderStudents() : renderLander()}
        </div>
    );
};